document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('CountryPopup');
  if (!popup) return;

  const openButtons = document.querySelectorAll('[data-open-country-popup]');
  const closeButtons = popup.querySelectorAll('[data-close-country-popup]');
  const modal = popup.querySelector('.country-popup__modal');

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('country-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('country-popup-open');
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openPopup();
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closePopup();
    });
  });

  popup.addEventListener('click', function (event) {
    if (modal && !modal.contains(event.target)) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });
});